import script from "./PasswordRegister.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordRegister.vue?vue&type=script&setup=true&lang=ts"

import "./PasswordRegister.vue?vue&type=style&index=0&id=4da57a9f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4da57a9f"]])

export default __exports__